export default __webpack_public_path__ + "static/media/code.de25fd26.wav";